// biome-ignore lint/suspicious/noShadowRestrictedNames: Immutable.js Map/Set
import { Map } from 'immutable';
import simpleReducer from '../common/utils/simple-reducer.js';
import { addLocale } from './actions.js';
import { FORM_NAME } from './constants.js';

const emptyMap = Map();

export default {
  [FORM_NAME]: simpleReducer(emptyMap, {
    [addLocale.FULFILLED](state: any) {
      return state.mergeIn(['data'], {
        language: undefined,
        country: undefined
      });
    }
  })
};
